import { WHATSAPP_HREF } from "@/lib/links";
import { trackWhatsAppClick } from "@/lib/analytics";

export default function WhatsAppFab() {
    return (
        <a
            href={WHATSAPP_HREF}
            data-testid="whatsapp-fab"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
                trackWhatsAppClick({
                    section: "floating",
                    buttonName: "fab_whatsapp",
                })
            }
            aria-label="Chat with Digitalbeej on WhatsApp"
            className="group fixed bottom-6 left-6 z-40 inline-flex items-center gap-3 bg-obsidian text-bone pl-4 pr-5 py-3 shadow-[0_18px_40px_-12px_rgba(0,0,0,0.4)] hover:bg-olive hover:text-obsidian transition-colors duration-300"
        >
            <span
                aria-hidden
                className="relative flex items-center justify-center w-7 h-7 bg-olive-mint text-obsidian"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-4 h-4"
                >
                    <path d="M19.077 4.928A9.967 9.967 0 0 0 12.011 2a9.97 9.97 0 0 0-8.654 14.93L2 22l5.21-1.328A9.97 9.97 0 0 0 12.01 22h.005a9.97 9.97 0 0 0 9.97-9.97 9.93 9.93 0 0 0-2.908-7.102zM12.011 20.298h-.004a8.27 8.27 0 0 1-4.214-1.154l-.302-.179-3.13.797.835-3.05-.197-.314A8.275 8.275 0 0 1 3.74 12.03c0-4.566 3.715-8.28 8.275-8.28a8.224 8.224 0 0 1 5.85 2.424 8.226 8.226 0 0 1 2.425 5.853c-.001 4.565-3.715 8.28-8.279 8.28zm4.54-6.198c-.247-.124-1.466-.724-1.693-.806-.227-.083-.392-.124-.557.125-.166.247-.64.806-.785.97-.144.166-.289.187-.536.063-.247-.125-1.046-.385-1.992-1.228-.736-.658-1.233-1.469-1.378-1.717-.144-.247-.015-.38.109-.503.111-.111.247-.289.371-.434.124-.144.165-.247.247-.412.083-.165.041-.31-.021-.434-.062-.124-.557-1.343-.763-1.84-.201-.482-.405-.417-.557-.425l-.475-.008c-.165 0-.434.062-.661.31s-.867.846-.867 2.064c0 1.219.887 2.396 1.011 2.561.124.165 1.747 2.667 4.232 3.74.591.255 1.052.408 1.412.522.593.188 1.133.162 1.56.099.476-.071 1.466-.6 1.673-1.18.207-.578.207-1.075.144-1.18-.062-.103-.227-.165-.474-.289z" />
                </svg>
                <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-olive-mint animate-ping" />
            </span>
            <span className="flex flex-col leading-tight">
                <span className="text-[10px] uppercase tracking-[0.22em] font-bold text-bone/60 group-hover:text-obsidian/60">
                    Talk to us
                </span>
                <span className="text-sm font-bold tracking-tight">
                    Chat on WhatsApp
                </span>
            </span>
            <span
                aria-hidden
                className="text-bone/70 group-hover:text-obsidian/70 transition-transform duration-300 group-hover:translate-x-1"
            >
                →
            </span>
        </a>
    );
}
